module.exports = __webpack_public_path__ + "img/chat.5491363d.svg";